/* eslint-disabled */
import Translation from "./Translation";
import LanguageExtend from "@/entity/extends/LanguageExtend";
import { hydrateCollection } from "@/Utils/EntityHelper";

export default class Language extends LanguageExtend {

public id = '';
public label = '';
public code = '';
public translations: Array<Translation> = [];

  constructor (object?: any) {
      super(object)
      if(object){
       this.id= object.id;
       this.label= object.label;
       this.code= object.code;
            hydrateCollection(object.translations, Translation, this.translations);
      }
      this.postConstruct()
  }

}
